/**
 * 输出金额值
 * @param value
 * @param {number} bit 有效位数
 * @returns { string }
 */
export function toStringPositiveFloat(value, bit = 2) {
  return String(value)
    .replace(/[^\d.]/gi, "") // 仅保留数字和小数点
    .replace(/^(\d*)(\.)?(.*)?$/, (match, $1 = "", $2 = "", $3 = "") => {
      // 整数部分，去除多余的前导0，最多保留一个
      const integerPart = $1.replace(/^0*/, "") || ($1 || $2 ? "0" : "");
      // 小数部分，仅保留一个小数点及小数点后有效位数
      const decimalPart = $3.replace(/\./gi, "").slice(0, bit);
      return `${integerPart}${$2}${decimalPart}`;
    });
}

/**
 * 输出实数
 * @param value
 * @returns { string }
 */
export function toStringNum(value) {
  const hasSymbol = String(value).indexOf("-") === 0;
  const filterStr = String(value).replace(/[^\\.\d]/gi, ""); // 仅保留数字和小数点
  const firstDotIndex = filterStr.indexOf("."); // 第一个小数点的位置
  const pureDigit = filterStr.replace(/[^\d]/gi, ""); // 仅数字
  let combineStr = "";
  if (firstDotIndex === -1) {
    combineStr = pureDigit ? pureDigit.replace(/^0*/, "") || "0" : "";
  } else {
    combineStr = `${
      pureDigit.substr(0, firstDotIndex).replace(/^0*/, "") || "0"
    }.${pureDigit.substr(firstDotIndex)}`;
  }
  return `${hasSymbol ? "-" : ""}${combineStr}`;
}

/**
 * 输出整数
 * @param value
 * @returns { string }
 */
export function toStringInt(value) {
  const hasSymbol = String(value).indexOf("-") === 0;
  const filterStr = String(value)
    .replace(/[^\d]/gi, "") // 仅保留数字
    .replace(/^0*(\d*)$/, (match, $1, index, str) => {
      return $1 || (str ? "0" : "");
    });
  return `${hasSymbol ? "-" : ""}${filterStr}`;
}

/**
 * 输出正整数
 * @param value
 * @returns { string }
 */
export function toStringPositiveInt(value) {
  return String(value)
    .replace(/[^\d]/gi, "") // 仅保留数字
    .replace(/^0*(\d*)$/, (match, $1) => {
      return $1 || "";
    });
}

/**
 * 输出非负整数，即包含0与正整数
 * @param value
 * @returns { string }
 */
export function toStringNonNegativeInt(value) {
  return String(value)
    .replace(/[^\d]/gi, "") // 仅保留数字
    .replace(/^0*(\d*)$/, (match, $1, index, str) => {
      return $1 || (str ? "0" : "");
    });
}

/**
 * 输出非表情符号，此方法可屏蔽大部分表情
 * 若要全部禁止，建议使用取反方式实现，即仅匹配支持的类型
 * @param value
 * @returns { string }
 */
export function toStringNonEmoji(value) {
  return String(value).replace(
    /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/g,
    ""
  );
}

/**
 * 补全金额小数位
 */
export function completeMoneyDecimal(value, maxLength = 2, fillString = "0") {
  if ([null, undefined, ""].includes(value)) {
    return value;
  }
  const [integer, decimal] = `${value}`.split(".");
  return `${integer}.${(decimal ?? "").padEnd(maxLength, fillString)}`;
}



// WEBPACK FOOTER //
// ./src/utils/tools/index.js